import { C } from "../../styles/theme";

export default function Dlg({ title, onClose, children }) {
  return (
    <div style={{ position: "fixed", inset: 0, background: "rgba(10,20,40,.65)", zIndex: 2000, display: "flex", alignItems: "center", justifyContent: "center", padding: 16, backdropFilter: "blur(4px)" }} onClick={onClose}>
      <div className="dialog-content" onClick={e => e.stopPropagation()}>
        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 18, paddingBottom: 12, borderBottom: `1px solid ${C.border}` }}>
          <h3 style={{ color: C.blue, fontWeight: 700, fontSize: 16, margin: 0 }}>{title}</h3>
          <button onClick={onClose} style={{ background: "#f1f5f9", border: "none", width: 28, height: 28, borderRadius: "50%", cursor: "pointer", fontSize: 14, color: C.gray, display: "flex", alignItems: "center", justifyContent: "center" }}>x</button>
        </div>
        {children}
      </div>
    </div>
  );
}
